// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pie-content[data-v-15345d1f]{inset:0;line-height:100%}", ""]);
// Exports
module.exports = exports;
